<template>
  <div class="offering">
    <h2 class="is-size-4-touch">Human Capital Consulting</h2>
    <p>
      Athena helps the client’s organization to revise and revamp the client’s
      existing HR policies so that they may further the client’s organizational
      goals. We work by closely examining the client’s business strategies and
      organizational requirements, devising multiple customized solutions, and
      helping the client’s organization to implement these strategies.
    </p>
    <p>Our methodology includes:</p>
    <ul>
      <li>Business strategy analysis;</li>
      <li>Organizational requirement appraisal;</li>
      <li>Current HR strategy integration; and finally,</li>
      <li>Complete policy augmentation.</li>
    </ul>
    <p>Our Strategic Human Capital Consulting & Advisory offerings are:</p>
    <ul>
      <li>Strategic HR.</li>
      <li>Competency Profiling and Mapping.</li>
      <li>HR Policies and Systems.</li>
      <li>
        Organizational Design and Restructuring with total rollout support.
      </li>
      <li>Change Management.</li>
      <li>Employee Engagement and Team Building Initiatives.</li>
      <li>
        Design & Implement Strategies to improve Talent Acquisition & Engagement
        Capabilities.
      </li>
      <li>Design & Implement Performance Management Systems.</li>
      <li>Development of Coaching & Mentoring skills.</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "OfferingHCC",
  props: {},
};
</script>
